import { ValidatorFn, FormGroup, ValidationErrors } from "@angular/forms";

export function englishSelectValidator(control: FormGroup): ValidationErrors | null {
    const english = control.value.studyEnglishInSchool;
    const englishStudyYears = control.value.englishStudyYears;
    const englishStydyHours = control.value.englishStudyHours;
    const englishTeacher = control.value.englishTeacherName;

    return english && !(englishStudyYears && englishStydyHours && englishTeacher) ? { "missingEnglishStudyInfo": true } : null;
}